var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"position-relative"},[_c('div',{staticClass:"position-relative"},[_c('canvas',{attrs:{"id":_vm.id,"height":"300"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }